module.exports = __webpack_public_path__ + "static/Gotham-LightItalic-1c93be60f02a75339bc33139cc17ee71.woff2";